import { ReactElement } from 'react';
import Table from '@/common/Table';

const AutomationTripsTableHeader = (): ReactElement => {
  return (
    <Table.Row header>
      <Table.Cell>Type</Table.Cell>
      <Table.Cell>Date</Table.Cell>
      <Table.Cell>SCH</Table.Cell>
      <Table.Cell>City</Table.Cell>
      <Table.Cell>AL</Table.Cell>
      <Table.Cell>FLT</Table.Cell>
      <Table.Cell>PLT</Table.Cell>
      <Table.Cell>FA</Table.Cell>
      <Table.Cell>DRV</Table.Cell>
      <Table.Cell>
        <i className="sv sv-power" />
      </Table.Cell>
      <Table.Cell>Van</Table.Cell>
      <Table.Cell>P/U</Table.Cell>
      <Table.Cell>D/O</Table.Cell>
      <Table.Cell>CLT</Table.Cell>
    </Table.Row>
  );
};

export default AutomationTripsTableHeader;
